import { render, staticRenderFns } from "./TagsInfo.vue?vue&type=template&id=b7233630&scoped=true&"
import script from "./TagsInfo.vue?vue&type=script&lang=js&"
export * from "./TagsInfo.vue?vue&type=script&lang=js&"
import style0 from "./TagsInfo.vue?vue&type=style&index=0&id=b7233630&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7233630",
  null
  
)

export default component.exports